import { render, staticRenderFns } from "./ShapeBrandLine.vue?vue&type=template&id=35921b51"
import script from "./ShapeBrandLine.vue?vue&type=script&lang=js"
export * from "./ShapeBrandLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports